const EnumPropName = Object.freeze({
  VOTE: "VOTE",
  SELF_FLAGGED: "SELF_FLAGGED",
  RISE_UP: "RISE_UP",
  MARK_AS_READ: "MARK_AS_READ",
  EDIT: "EDIT",
});

export default EnumPropName;
